import Router from "next/router";

import redirects from "~/data/redirects.json";

if (process.env.NEXT_MODE === "spa") {
    Router.events.on("routeChangeStart", route => {
        let routeTrailing = "";
        let routeNonTrailing = "";

        // Create a version with and without a trailing slash
        if (route.endsWith("/")) {
            routeTrailing = route;
            routeNonTrailing = route.slice(0, -1);
        } else {
            routeTrailing = route + "/";
            routeNonTrailing = route;
        }

        // Check both versions for redirect entry
        if (Object.prototype.hasOwnProperty.call(redirects, routeTrailing))
            return Router.replace(redirects[routeTrailing]);
        else if (
            Object.prototype.hasOwnProperty.call(redirects, routeNonTrailing)
        )
            return Router.replace(redirects[routeNonTrailing]);
    });
}
